import React from 'react';
import { i18n } from 'utils/i18n';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import TermsOfUseVanModalContent from 'components/ReservationFlow/VehicleSelect/Modals/TermsOfUseVanModalContent';

const TermsOfUseVanModal = () => (
  <Modal
    modalKey={MODAL.VAN_SELECTED_12_AND_15_TERMS_USE}
    header={i18n('terms_use_van_model_main_title')}
    theme={MODAL_THEMES.WHITE}
  >
    <TermsOfUseVanModalContent />
  </Modal>
);

export default TermsOfUseVanModal;
